import React, { useState, useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import AdminLayout from './AdminLayout';

const PrivateRoute = ({ children, requiredRole }) => {
    const { currentUser } = useAuth();
    const [hasAccess, setHasAccess] = useState(null);

    useEffect(() => {
        const checkAccess = async () => {
            if (!currentUser) {
                setHasAccess(false);
                return;
            }

            // If no specific role required, just check if logged in
            if (!requiredRole) {
                setHasAccess(true);
                return;
            }

            // Check user's role
            try {
                const tokenResult = await currentUser.getIdTokenResult();
                const userRole = tokenResult.claims.role;
                const isAdmin = tokenResult.claims.admin === true;

                // Admin always has access
                if (isAdmin) {
                    setHasAccess(true);
                    return;
                }

                // Check if user has required role
                if (userRole === requiredRole) {
                    setHasAccess(true);
                } else {
                    setHasAccess(false);
                }
            } catch (error) {
                console.error('Error checking role:', error);
                setHasAccess(false);
            }
        };

        checkAccess();
    }, [currentUser, requiredRole]);

    // Loading state
    if (hasAccess === null) {
        return (
            <div style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                height: '100vh'
            }}>
                <i className="fas fa-spinner fa-spin" style={{ fontSize: '32px', color: '#667eea' }}></i>
            </div>
        );
    }

    // Not logged in
    if (!currentUser) {
        return <Navigate to="/login" />;
    }

    // Logged in but no access
    if (!hasAccess) {
        return (
            <AdminLayout>
                <div style={{
                    padding: '40px',
                    textAlign: 'center',
                    maxWidth: '600px',
                    margin: '100px auto'
                }}>
                    <i className="fas fa-lock" style={{ fontSize: '64px', color: '#dc3545', marginBottom: '20px' }}></i>
                    <h2>Acesso Negado</h2>
                    <p>Você não tem permissão para acessar esta página.</p>
                    <p style={{ color: '#666' }}>
                        Role necessário: <strong>{requiredRole}</strong>
                    </p>
                </div>
            </AdminLayout>
        );
    }

    return <AdminLayout>{children}</AdminLayout>;
};

export default PrivateRoute;
